// @flow

import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { css } from 'glamor'
import { v2black, Link } from '@paypalcorp/pp-react'
import { getFormattedAmount } from '../amount-utils'
import {
  smallAndSmaller,
  phoneLandscapeMinAndSmaller,
  phoneLandscapeMaxAndSmaller,
} from 'lib/styles/media-queries'

const FadeIn = css.keyframes({ from: { opacity: 0 }, to: { opacity: 1 } })

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  color: v2black,
  marginBottom: '20px',
  '& .productText': {
    color: 'inherit',
    fontWeight: 'normal',
    fontSize: '0.857rem',
    fontFamily: 'inherit',
    textAlign: 'left',
    lineHeight: '1.25',
    marginBottom: '10px',
  },
  '& .productName': {
    display: '-webkit-box',
    verticalAlign: 'middle',
    textOverflow: 'ellipsis',
    width: '100%',
    overflow: 'hidden',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
  },
  '& .productPrice': {
    marginBottom: '10px',
    lineHeight: '1',
  },
})

const ProductImage = glamorous.img(({ photoHeightLg, photoHeightSm }) => ({
  width: '100%',
  height: photoHeightLg,
  borderRadius: '15px',
  marginBottom: '5px',
  animation: `${FadeIn} 0.5s`,
  [smallAndSmaller]: {
    height: photoHeightSm,
  },
  [phoneLandscapeMaxAndSmaller]: {
    height: '175px',
  },
  [phoneLandscapeMinAndSmaller]: {
    height: '150px',
  },
}))

ProductMiniView.defaultProps = {
  photoUrl: 'https://www.paypalobjects.com/profiles/cover/green.jpg',
  price: {},
  photoHeightLg: '105px',
  photoHeightSm: '185px',
}

ProductMiniView.propTypes = {
  photoUrl: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  productClickHandler: PropTypes.func,
  price: PropTypes.exact({
    amount: PropTypes.string,
    currencyCode: PropTypes.string,
  }),
}

function ProductMiniView(props) {
  const {
    photoUrl,
    name,
    productClickHandler,
    price,
    photoHeightLg,
    photoHeightSm,
    id,
  } = props

  return (
    <Container>
      <Link onClick={() => productClickHandler(id)}>
        <ProductImage
          photoHeightLg={photoHeightLg}
          photoHeightSm={photoHeightSm}
          alt={name}
          src={photoUrl}
        />
      </Link>

      <Link
        onClick={() => productClickHandler(id)}
        className="productName productText"
      >
        {name}
      </Link>

      <Link onClick={() => productClickHandler(id)} className="productText">
        <strong className="productPrice">
          {getFormattedAmount({
            amount: price.amount,
            currencyCode: price.currencyCode,
          })}
        </strong>
      </Link>
    </Container>
  )
}

export default ProductMiniView
